// extracted by mini-css-extract-plugin
export default {"languages-popover-button":"_u34ttt","languagesPopoverButton":"_u34ttt"};